/**
 * List Routes
 */
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
// async components
import PainelControle from "./PainelControle";
import FaturaEscola from "./FaturaEscola";

const IndexPacote = ({ match, history }) => (
  <div className="content-wrapper">
    <Switch>
      <Redirect
        exact
        from={`${match.url}/`}
        to={`${match.url}/painel-controle`}
      />
      <Route
        path={`${match.url}/fatura-escola/:escolaId?/:ano?/:mes?`}
        component={FaturaEscola}
      />
      <Route path={`${match.url}/painel-controle`} component={PainelControle} />
    </Switch>
  </div>
);

export default IndexPacote;
